import { all, call } from "redux-saga/effects";
import userSaga from "./handlers/userHandlers";
import checklistSaga from "./handlers/checklistHandlers";
import defectsSaga from "./handlers/defectsHandlers";
import mastersSaga from "./handlers/mastersHandlers";
import repairsSaga from "./handlers/repairsHandlers";
import dashboardSaga from "./handlers/dashboardHandler";
import accountSaga from "./handlers/accountHandlers";
export default function* rootSaga() {
  yield all([
    call(userSaga),
    call(checklistSaga),
    call(defectsSaga),
    call(mastersSaga),
    call(repairsSaga),
    call(dashboardSaga),
    call(accountSaga),
  ]);
}
